import { render, staticRenderFns } from "./CreateCoupon.vue?vue&type=template&id=72e75e0d&scoped=true&"
import script from "./CreateCoupon.vue?vue&type=script&lang=ts&"
export * from "./CreateCoupon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e75e0d",
  null
  
)

export default component.exports